import S3Json from "../model/interceptor/S3JsonInterceptor";

export function getDataSource(url) {
    return S3Json.get(url)
}
